<template>
  <v-app-bar variant="compact" :app="true" color="var(--color-brand-200)">
    <template v-if="gotTranslations">
      <v-toolbar-items v-for="(item, index) in getNavItems()" :key="index">
        <v-btn
          v-if="item.badges && item.badgeValue > 0"
          variant="text"
          :aria-label="item.a11y"
          @click="navigate(item, index)"
        >
          <v-badge :content="item.badgeValue" bottom right />
          <div :class="getNavClass(item.index)" v-text="item.name" />
        </v-btn>
        <v-btn
          v-else
          variant="text"
          :aria-label="item.a11y"
          @click="navigate(item, index)"
        >
          <div :class="getNavClass(item.index)" v-text="item.name" />
        </v-btn>
      </v-toolbar-items>
    </template>
    <v-spacer />
    <HelpInformation
      color="var(--color-brand-200)"
      style="padding-right: 0.3vw; padding-left: 0.3vw"
    />
    <v-avatar variant="outlined" color="var(--color-brand)">
      <span color="var(--color-white)">{{ getAvatarDisplayName(true) }}</span>
    </v-avatar>
    <v-btn
      icon="mdi-dots-vertical"
      :class="getNavClass(10)"
      size="small"
      @click="doSettings()"
    />
    <v-btn
      icon="mdi-logout-variant"
      :class="getNavClass(20)"
      size="small"
      @click="userLogout()"
    />
  </v-app-bar>
</template>

<script>
import adminStore from '@/stores/adminstore'
import userStore from '@/stores/userstore'
import { mapActions, mapState, mapGetters } from 'pinia'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'NavigationSystem',
  components: {
    HelpInformation: defineAsyncComponent(
      () => import('@/components/menues/HelpInformation.vue')
    )
  },
  props: {
    location: { type: String, default: 'top' }
  },
  computed: {
    ...mapState(adminStore, ['getLanguage', 'getSiteLanguage'])
  },
  watch: {
    getSiteLanguage(updated, old) {
      console.log('LANG CHANGED (%s) (%s)', updated, old)
      this.translateMenues()
    },
    getSiteLanguage(updated, old) {
      console.log('getSiteLanguage CHANGED (%s) (%s)', updated, old)
      let aStore = adminStore()
      aStore.translationMap = new Map()
      this.translateMenues()
    }
  },
  data() {
    return {
      activeMenyItem: -1,
      countUnassessed: 0,
      gotTranslations: false,
      menu0: '',
      menu1: '',
      menu2: '',
      menu3: ''
    }
  },
  mounted() {
    this.setActiveNavItem(-1)
    this.translateMenues()
  },
  methods: {
    ...mapActions(adminStore, [
      'setActiveNavItem',
      'geti18nTranslation',
      'logout'
    ]),
    ...mapGetters(adminStore, ['getActiveNavItem', 'getIdToken']),
    ...mapActions(userStore, ['']),
    ...mapGetters(userStore, ['isLoggedIn', 'getDisplayName']),
    translateMenues() {
      // console.log('TRANSLATING MENUES')
      this.geti18nTranslation('nav.nav0').then((t0) => {
        this.menu0 = t0
        this.geti18nTranslation('nav.nav1').then((t1) => {
          this.menu1 = t1
          this.geti18nTranslation('nav.nav2').then((t2) => {
            this.menu2 = t2
            this.geti18nTranslation('nav.nav3')
              .then((t3) => {
                this.menu3 = t3
              })
              .finally(() => {
                this.gotTranslations = true
              })
          })
        })
      })
    },
    getActiveNav() {
      // console.log('getActiveNav(%j)', this.getActiveNavItem())
      return this.getActiveNavItem()
    },
    getAvatarDisplayName(avatar) {
      if (avatar) {
        let name = this.getDisplayName() || 'No Name'
        let nameParts = name.split(' ')
        //    console.log('NAMEPARTS (%s) (%s)', nameParts[0], nameParts[1])
        if (nameParts.length > 1) {
          return (
            nameParts[0].substring(0, 1).toUpperCase() +
            nameParts[1].substring(0, 1).toUpperCase()
          )
        } else if (nameParts.length > 0) {
          return nameParts[0].substring(0, 1).toUpperCase()
        } else {
          return ''
        }
      } else {
        return this.getDisplayName()
      }
    },
    getNavClass(navIndex) {
      //  console.log('GET NAV CLASS (%s) (%s)', this.getActiveNav(), navIndex)
      if (this.getActiveNav() === navIndex) {
        return 'labelactive'
      } else {
        return 'label'
      }
    },
    navigate(item, itemIndex) {
      //   console.log('NAVIGATE got called !', item)
      // item.index = itemIndex;
      this.setActiveNavItem(item)
      this.$router
        .push({
          name: item.pathName
        })
        .catch((err) => {
          console.log(err)
        })
    },
    doSettings() {
      var newPath = '/settings/'
      //   console.log('++++++++++ NEW PATH (' + newPath + ')')
      this.setActiveNavItem(10)
      this.activeMenyItem = 10
      this.$router
        .push({
          name: 'UserSettings'
        })
        .catch(() => {})
    },
    getNavItems() {
      return [
        {
          /* 0  */
          index: 0,
          name: this.menu0,
          a11y: this.menu0,
          pathName: 'ParentsStart'
        },
        {
          /* 1 */
          index: 1,
          name: this.menu1,
          a11y: this.menu1,
          pathName: 'KindergartenStart'
        },
        {
          /* 3 */
          index: 2,
          name: this.menu3,
          a11y: this.menu3,
          pathName: 'SchoolAdmin'
        },
        {
          /* 2 */
          index: 3,
          name: this.menu2,
          a11y: this.menu2,
          pathName: 'UserSettings'
        }
      ]
    },
    userLogout() {
      let token = this.getIdToken()
      console.log('logout got called !')
      localStorage.removeItem('lid')
      localStorage.removeItem('sid')
      localStorage.removeItem('ssa')
      this.setActiveNavItem(20)
      this.activeMenyItem = 20
      this.logout2()

      //          window.open('https://auth.dataporten.no/logout', '_self', true)
      /*
      window.open(
        `https://auth.dataporten.no/openid/endsession?post_logout_redirect_uri=https://www.v4l.no/utlogget&id_token_hint=${token}`,
        '_self',
        true
      )
       */
    },
    logout2() {
      console.log('logout2 got called !')
      localStorage.removeItem('lid')
      localStorage.removeItem('sid')
      localStorage.removeItem('ssa')
      this.logout()
        .then(() => {})
        .catch((error) => {
          console.error('PROBLEMS LOGGING OUT (%o)', error)
        })
        .finally(() => {
          this.$router
            .push({
              name: 'LogOut',
              force: true
            })
            .catch(() => {})
          this.$router.go(0)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-wrapper {
  border-top: 1px solid var(--color-main-header);
  padding: 0.5rem 0 0.5rem 0;
}
.nav {
  // display: flex;
  align-items: center;
}
.nav-item {
  // flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  &.active {
    color: var(--color-brand-100);
  }
}
.icon {
  margin-bottom: 0.5rem;
}

.label {
  color: var(--color-white);
  display: flex;
  font-size: 0.88rem;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.02rem;
  text-decoration: none;
  cursor: pointer;
}

.labelactive {
  color: var(--color-white);
  display: flex;
  font-size: 1rem;
  text-align: center;
  letter-spacing: 0.05rem;
  font-weight: 900;
}

.active {
  color: var(--color-white);
  font-size: 1rem;
  font-weight: 800;
}
</style>
